import mapboxgl, { LngLatLike } from 'mapbox-gl';

// import MapboxLanguage from '@mapbox/mapbox-gl-language';

function inViewport(element: HTMLElement) {
  if (!element) return false;
  if (1 !== element.nodeType) return false;

  const html = document.documentElement;
  const rect = element.getBoundingClientRect();

  return !!rect &&
    rect.bottom >= 0 &&
    rect.right >= 0 &&
    rect.left <= html.clientWidth &&
    rect.top <= html.clientHeight;
}

$(() => {
  const $map = $('.map-element') as JQuery<HTMLElement>;
  const windowWidth = $(window).width() as number;
  const mapMarkerCompanyPosition: LngLatLike = [22.1385, 51.19382];
  const mapMarkerCountryPosition: LngLatLike = [19.3221, 52.15523];

  mapboxgl.accessToken = 'pk.eyJ1IjoicGl4ZWVsIiwiYSI6ImNrNnIxN2xndjAxNDEzZXBkM210aXRncjQifQ.djHfvY0IfcEv5TIJn4Uakw';

  const mapState: any = {
    toggle: false,
  };

  const map = new mapboxgl.Map({
    container: $map.get(0), // container ID
    style: 'mapbox://styles/pixeel/ckyf7gpmp0yw114rxrtxh6pqb',
    center: mapMarkerCountryPosition,
    zoom: 7,
  });

  const disableMapInteraction = (map: mapboxgl.Map) => {
    map.scrollZoom.disable();
    map.dragPan.disable();
    map.touchPitch.disable();
  };

  const enableMapInteraction = (map: mapboxgl.Map) => {
    map.scrollZoom.enable();
    map.dragPan.enable();
    map.touchPitch.enable();
  };

  $('[data-action="toggle-map-fly"]').fadeOut();

  map.on('load', () => {

    disableMapInteraction(map);

    const marker = new mapboxgl.Marker({ color: '#89b5ff' }).setLngLat(mapMarkerCompanyPosition).addTo(map);

    setTimeout(() => {
      map.flyTo({
        center: mapMarkerCompanyPosition,
        speed: 0.5,
        curve: 0.5,
        zoom: 8,
      }).once('zoomend', () => {
        enableMapInteraction(map);
        mapState.toggle = false;
        $('[data-action="toggle-map-fly"]').fadeIn(200);
      });
    }, 400);

  });

  $(document).on('click', '[data-action="toggle-map-fly"]', e => {
    e.preventDefault();

    if (mapState.toggle) {
      map.stop()
        .once('zoomstart', () => {
          disableMapInteraction(map);
          $(e.currentTarget).fadeOut(200);
        })
        .once('zoomend', () => {
          enableMapInteraction(map);
          mapState.toggle = false;
          $(e.currentTarget).html('Przybliż widok');
          $(e.currentTarget).fadeIn(200);
        })
        .flyTo({
          center: mapMarkerCompanyPosition,
          zoom: 12,
          speed: 0.5,
          pitch: 0,
          bearing: 0,
        });
    } else {
      map.stop()
        .once('zoomstart', () => {
          disableMapInteraction(map);
          $(e.currentTarget).fadeOut(200);
        })
        .once('zoomend', () => {
          enableMapInteraction(map);
          mapState.toggle = true;
          $(e.currentTarget).html('Oddal widok');
          $(e.currentTarget).fadeIn(200);
        })
        .flyTo({
          center: mapMarkerCompanyPosition,
          zoom: 17,
          speed: 1.5,
          curve: 0.5,
          pitch: 45,
          bearing: 20,
          // maxDuration: 3000,
        });

    }
  });

});